import { render, staticRenderFns } from "./EditPdpTable.vue?vue&type=template&id=da2fba02&scoped=true"
import script from "./EditPdpTable.ts?vue&type=script&lang=ts&external"
export * from "./EditPdpTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditPdpTable.vue?vue&type=style&index=0&id=da2fba02&prod&scoped=true&lang=css"
import style1 from "./EditPdpTable.vue?vue&type=style&index=1&id=da2fba02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2fba02",
  null
  
)

export default component.exports